import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { WidgetTypes } from 'interfaces';
import OmniSearchButtonIcon from './OmniSearchButtonIcon.CB';

export default defineComponent({
	props: {
		studyId: Number,
		widgetType: String,
		widgetLocation: String,
		emptyText: String,
	},
	setup: (props) => {
		const studyId = props.studyId as number;
		const widgetType = props.widgetType as WidgetTypes;
		const widgetLocation = props.widgetLocation as string;
		const emptyText = props.emptyText as string;

		const codeBehind = new OmniSearchButtonIcon(
			studyId,
			widgetType,
			widgetLocation,
			emptyText,
		);

		return setupComponent(codeBehind);
	},
});
